import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, watch } from 'vue';

interface B2BDeliveryData {
    phoneNumber: string;
    email: string;
    notes: string;
    deliveryDays: string[];
}

interface WeekDay {
    key: string;
    label: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'B2BDeliverySection',
  props: {
    b2bDeliveryPhone: null,
    b2bDeliveryEmail: null,
    b2bDeliveryNotes: null,
    b2bDeliveryDays: null,
    canAccessLogistics: { type: Boolean }
  },
  emits: ["b2b-delivery-change"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'b2b-delivery-change', payload: { isB2BDelivery: boolean; data: B2BDeliveryData }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    b2bDeliveryPhone?: string | null;
    b2bDeliveryEmail?: string | null;
    b2bDeliveryNotes?: string | null;
    b2bDeliveryDays?: string | string[] | null;
    canAccessLogistics: boolean;
};





const parseDeliveryDays = (value: string | string[] | null | undefined): string[] => {
    if (Array.isArray(value)) {
        return value;
    }

    return [];
};

const normalizedDeliveryDays = parseDeliveryDays(props.b2bDeliveryDays);

const isB2BDelivery = ref(false);

const b2bDeliveryData = reactive<B2BDeliveryData>({
    phoneNumber: props.b2bDeliveryPhone || '',
    email: props.b2bDeliveryEmail || '',
    notes: props.b2bDeliveryNotes || '',
    deliveryDays: normalizedDeliveryDays,
});

const weekDays: WeekDay[] = [
    { key: 'monday', label: 'Monday' },
    { key: 'tuesday', label: 'Tuesday' },
    { key: 'wednesday', label: 'Wednesday' },
    { key: 'thursday', label: 'Thursday' },
    { key: 'friday', label: 'Friday' },
];

const emitChange = () => {
    emit('b2b-delivery-change', {
        isB2BDelivery: isB2BDelivery.value,
        data: { ...b2bDeliveryData, deliveryDays: [...b2bDeliveryData.deliveryDays] },
    });
};

const toggleDeliveryDay = (dayKey: string) => {
    const index = b2bDeliveryData.deliveryDays.indexOf(dayKey);
    if (index > -1) {
        b2bDeliveryData.deliveryDays.splice(index, 1);
    } else {
        b2bDeliveryData.deliveryDays.push(dayKey);
    }
    emitChange();
};

watch(
    () => [b2bDeliveryData.phoneNumber, b2bDeliveryData.email, b2bDeliveryData.notes],
    () => {
        emitChange();
    },
);

return { __sfc: true,props, emit, parseDeliveryDays, normalizedDeliveryDays, isB2BDelivery, b2bDeliveryData, weekDays, emitChange, toggleDeliveryDay }
}

})